import React from "react";
import _reportsRenderParams from "./components/renderParams";
import params from "./components/params.json";
import Resolvers from "../../../../componets/Api/internal/service/reports";

class reports extends React.Component {
  state = {
    reports: [],
    selectedReports: null,
  };

  getAllReports = () => {
  };

  GetPropsData = async (s, idx) => {
    var _subdata = await Resolvers({
      ...this.props,
      GetData: true,
      sqlstring: s,
    });
    if (_subdata.status === 200) {
      let prm = s;
      prm[idx] = { ...prm[idx], optionsData: _subdata.data };
      return prm;
    }
    return [];
  };

  Change = (e) => {
    e.params.forEach((el, idx) => {
      el = this.GetPropsData(el, idx);
    });
    this.setState({ selectedReports: e });
  };

  componentDidMount() {
    this.props.setHeaderPage({
      Icon: (
        <this.props._icon
          iodocumenttextoutline
          className="c-placeholder c-green"
        />
      ),
      Title: "Moje reporty",
      SubTitle: "",
    });
    const reports = params;
    this.setState({ reports: reports });
  }

  render() {
    const { Bs, VARIANT, SIZE } = this.props;
    return (
      <>
        <Bs div>
          <Bs cardbody>
          <Bs strong>Vybrat report</Bs>
            <Bs row>
              <Bs col xs={12}>
                <Bs
                  brtxselect
                  options={this.state.reports}
                  placeholder="Vyber report"
                  value={this.state.selectedReports}
                  onChange={(e) => {
                    this.Change(e);
                  }}
                />
              </Bs>
            </Bs>
          </Bs>
        </Bs>

        {this.state.selectedReports && (
          <_reportsRenderParams
            {...this.props}
            selectedReports={this.state.selectedReports}
            GetPropsData={this.GetPropsData}
            setState={(e) => this.setState(e)}
          />
        )}
      </>
    );
  }
}

export default reports;
